(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goatt-collection-grille"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.gcgInit) return; root.dataset.gcgInit='1';
    var sort=root.querySelector('.js-gcg-sort');
    if(sort) sort.addEventListener('change', function(){
      var u=new URL(window.location); u.searchParams.set('sort_by', this.value); u.searchParams.delete('page'); window.location=u.toString();
    });
    var facets=root.querySelector('.js-gcg-facets'), scrim=root.querySelector('.js-gcg-scrim');
    var open=root.querySelector('.js-gcg-open'), close=root.querySelector('.js-gcg-close');
    function o(){ facets.classList.add('is-open'); if(scrim) scrim.hidden=false; }
    function c(){ facets.classList.remove('is-open'); if(scrim) scrim.hidden=true; }
    if(open) open.addEventListener('click', o);
    if(close) close.addEventListener('click', c);
    if(scrim) scrim.addEventListener('click', c);
  }
  function boot(){ document.querySelectorAll('.gcg').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goatt-finder-racket"] && !Shopify.designMode) return;
  try {
    
(function(){
const Q = [
  { q:"Où tu en es au tennis ?", hint:"Sois honnête, aucune mauvaise réponse.",
    opts:[
      {ic:"🎾", t:"Je débute", d:"Je commence tout juste ou presque", v:{niv:"debutant"}},
      {ic:"😎", t:"Je joue pour le plaisir", d:"De temps en temps, sans club", v:{niv:"loisir"}},
      {ic:"🏸", t:"Je joue régulièrement", d:"En club, plusieurs fois par mois", v:{niv:"inter"}},
      {ic:"🏆", t:"Je fais de la compétition", d:"Matchs officiels, tournois", v:{niv:"confirme"}},
    ]},
  { q:"Ton gabarit / ta force ?", hint:"Ça nous aide à doser le poids à ta place.",
    opts:[
      {ic:"🪶", t:"Léger·ère ou ado", d:"Petit gabarit, ou junior", v:{phys:"leger"}},
      {ic:"🧍", t:"Dans la moyenne", d:"Ni costaud ni menu", v:{phys:"moyen"}},
      {ic:"💪", t:"Costaud·e, je frappe fort", d:"Physique athlétique", v:{phys:"fort"}},
    ]},
  { q:"Qu'est-ce qui te manque le plus ?", hint:"Le point qui te frustre le plus dans tes matchs.",
    opts:[
      {ic:"🚀", t:"De la puissance", d:"Mes balles ne vont pas assez loin / fort", v:{bes:"puissance"}},
      {ic:"🎯", t:"De la précision", d:"Mes balles partent souvent dehors", v:{bes:"controle"}},
      {ic:"🌀", t:"De l'effet", d:"Je n'arrive pas à faire tourner la balle", v:{bes:"effet"}},
      {ic:"🤷", t:"Je ne sais pas trop", d:"Un peu de tout, je veux progresser", v:{bes:"polyvalent"}},
    ]},
  { q:"Et ton bras ?", hint:"Coude / épaule : fragiles ou solides ?",
    opts:[
      {ic:"🩹", t:"Déjà eu mal (ou fragile)", d:"Je veux du confort avant tout", v:{bras:"oui"}},
      {ic:"👍", t:"Tout va bien", d:"Aucun souci de ce côté", v:{bras:"non"}},
    ]},
];

// Collections cibles
const C = {
  facile:"/collections/raquettes-255-280gr",       // léger / débutant-loisir
  inter:"/collections/raquettes-284-299gr",         // intermédiaire
  confirme:"/collections/toutes-nos-raquettes-tennis",
  puissance:"/collections/raquettes-puissance",
  controle:"/collections/raquettes-controle",
  effet:"/collections/raquettes-effet",
  polyvalent:"/collections/raquettes-polyvalent-1",
};
const BES = {
  puissance:{mot:"la puissance", url:C.puissance},
  controle:{mot:"le contrôle", url:C.controle},
  effet:{mot:"l'effet (le lift)", url:C.effet},
  polyvalent:{mot:"la polyvalence", url:C.polyvalent},
};

function poids(a){
  // débutant/loisir => toujours léger & tolérant, quel que soit le gabarit
  if(a.niv==="debutant") return {label:"Légère (≤ 285 g)", val:"leger", txt:"légère, maniable et très tolérante"};
  if(a.niv==="loisir")  return a.phys==="fort" ? {label:"Légère à moyenne (285-295 g)",val:"moyen",txt:"légère à moyenne et facile à jouer"} : {label:"Légère (≤ 285 g)",val:"leger",txt:"légère et facile à jouer"};
  if(a.niv==="inter")   return a.phys==="leger" ? {label:"Moyenne (285-295 g)",val:"moyen",txt:"maniable et équilibrée"} : {label:"Moyenne (290-300 g)",val:"moyen",txt:"équilibrée, un bon compromis"};
  // confirmé
  return a.phys==="leger" ? {label:"Moyenne (290-300 g)",val:"moyen",txt:"assez précise mais maniable"} : {label:"Lourde (300 g+)",val:"lourd",txt:"lourde, stable et précise"};
}

function finish(){
  const a=ans;
  const p=poids(a);
  const b=BES[a.bes]||BES.polyvalent;

  // Titre / badge
  let badge, title;
  if(a.niv==="debutant"||a.niv==="loisir"){ badge="Ton profil"; title="FACILE & TOLÉRANTE"; }
  else { badge="Ton profil"; title = (a.bes==="polyvalent") ? "ÉQUILIBRÉE" :
          a.bes==="puissance"?"ORIENTÉE PUISSANCE": a.bes==="controle"?"ORIENTÉE CONTRÔLE":"ORIENTÉE EFFET"; }

  // Texte
  let txt;
  if(a.niv==="debutant"){
    txt = `Pour bien débuter, il te faut une raquette ${p.txt} : elle pardonne les fautes de frappe et t'aide à envoyer la balle dans le court sans forcer. On évite les cadres lourds et exigeants — ils te fatigueraient et te dégoûteraient vite.`;
  } else if(a.niv==="loisir"){
    txt = `Pour le plaisir, vise une raquette ${p.txt}, confortable et sans prise de tête. Ce qui compte, c'est que tu prennes du bon temps sur le court.`;
  } else if(a.niv==="inter"){
    txt = `Tu as les bases : une raquette ${p.txt} te donnera un bon socle, en allant chercher ${b.mot}, là où tu veux progresser.`;
  } else {
    txt = `À ton niveau, tu peux emmener une raquette ${p.txt}, taillée pour ${b.mot}. Tu as le jeu pour en tirer parti.`;
  }
  if(a.bes && a.niv!=="debutant"){
    const nuance={puissance:" On privilégie des cadres qui donnent de la vitesse de balle sans que tu forces.",controle:" On cherche un cadre précis, pour placer tes balles et arrêter de les envoyer dehors.",effet:" On vise un cadre qui t'aide à lifter : la balle tourne, retombe tôt et gêne l'adversaire.",polyvalent:" On part sur un cadre qui fait tout bien — parfait pour continuer à progresser."};
    txt += nuance[a.bes]||"";
  }
  if(a.bras==="oui"){ txt += " Comme tu fais attention à ton bras, on choisit un cadre souple et confortable — et on te conseillera un cordage doux (multifilament) à tension modérée."; }

  // Specs lisibles
  const nivLabel={debutant:"Débutant",loisir:"Loisir",inter:"Intermédiaire",confirme:"Confirmé"}[a.niv];
  document.getElementById('rspecs').innerHTML =
    `<div class="spec"><b>Niveau</b>${nivLabel}</div>`+
    `<div class="spec"><b>Poids conseillé</b>${p.label}</div>`+
    `<div class="spec"><b>Priorité</b>${a.niv==="debutant"?"Tolérance & maniabilité":cap(b.mot)}</div>`+
    (a.bras==="oui"?`<div class="spec"><b>Bras</b>Confort priorisé</div>`:``);

  // CTA principal
  let ctaUrl, ctaLabel;
  if(a.niv==="debutant"||a.niv==="loisir"){ ctaUrl=C.facile; ctaLabel="Voir les raquettes faciles →"; }
  else { ctaUrl=b.url; ctaLabel=`Voir les raquettes ${b.mot.replace("le ","").replace("la ","").replace("l'","")} →`; }

  document.getElementById('rbadge').textContent=badge;
  document.getElementById('rtitle').textContent=title;
  document.getElementById('rtext').textContent=txt;
  const cta=document.getElementById('rcta'); cta.href=ctaUrl; cta.textContent=ctaLabel;

  // Liens secondaires
  const nivUrl = a.niv==="inter"?C.inter : a.niv==="confirme"?C.confirme : C.facile;
  document.getElementById('ralso').innerHTML =
    `<a href="${b.url}">Style : ${cap(b.mot)}</a>`+
    `<a href="/pages/grille-babolat">Par marque</a>`+
    `<a href="/blogs/news/bien-choisir-sa-raquette">Lire le guide</a>`;

  document.getElementById('result').classList.add('show');
  window.scrollTo({top:0,behavior:'smooth'});
}
function cap(s){s=s.replace(/^l'|^le |^la /,'');return s.charAt(0).toUpperCase()+s.slice(1);}

let step=0; const ans={};
const quiz=document.getElementById('quiz'), prog=document.getElementById('progress');
function render(){
  prog.innerHTML=Q.map((_,i)=>`<span class="dot ${i<step?'done':''} ${i===step?'on':''}"></span>`).join('');
  const c=Q[step];
  quiz.innerHTML=`<div class="q">${c.q}</div><div class="qhint">${c.hint}</div>
    <div class="opts">${c.opts.map((o,i)=>`<div class="opt" onclick="choose(${i})"><div class="ic">${o.ic}</div><h3>${o.t}</h3><p>${o.d}</p></div>`).join('')}</div>
    ${step>0?`<button class="back" onclick="back()">← Précédent</button>`:''}`;
}
function choose(i){ Object.assign(ans,Q[step].opts[i].v); step++; step<Q.length?render():(quiz.style.display='none',prog.style.display='none',finish()); }
function back(){ if(step>0){step--;render();} }
function restart(){ step=0; for(const k in ans)delete ans[k]; document.getElementById('result').classList.remove('show'); quiz.style.display=''; prog.style.display=''; render(); window.scrollTo({top:0,behavior:'smooth'}); }
render();
window.choose=choose;window.back=back;window.restart=restart;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goatt-finder-string"] && !Shopify.designMode) return;
  try {
    
(function(){
const Q=[
  { q:"Ton profil de jeu ?", hint:"Ce que tu recherches avant tout.",
    opts:[
      {ic:"P", t:"Puissance", d:"Je veux de la vitesse et du répondant", v:{prof:"puissance"}},
      {ic:"C", t:"Contrôle", d:"Je frappe fort, il me faut de la précision", v:{prof:"controle"}},
      {ic:"♥", t:"Confort", d:"Douceur avant tout, ménager mon bras", v:{prof:"confort"}},
    ]},
  { q:"Ton bras ?", hint:"Historique de douleurs coude/épaule.",
    opts:[
      {ic:"!", t:"Sensible", d:"J'ai (eu) un tennis elbow ou des douleurs", v:{bras:"oui"}},
      {ic:"✓", t:"Solide", d:"Aucun souci", v:{bras:"non"}},
    ]},
  { q:"Tu casses souvent ?", hint:"Fréquence de casse de tes cordages.",
    opts:[
      {ic:"↑", t:"Souvent", d:"Je casse vite, je frappe lourd", v:{casse:"souvent"}},
      {ic:"=", t:"Parfois", d:"De temps en temps", v:{casse:"parfois"}},
      {ic:"↓", t:"Rarement", d:"Mes cordages durent", v:{casse:"rare"}},
    ]},
  { q:"Ton budget ?", hint:"Par garniture (12 m).",
    opts:[
      {ic:"€", t:"Essentiel", d:"Le meilleur rapport qualité-prix", v:{bud:"eco"}},
      {ic:"€€", t:"Performance", d:"Je mets le prix pour du bon", v:{bud:"moy"}},
      {ic:"€€€", t:"Premium", d:"Je veux le haut de gamme", v:{bud:"prem"}},
    ]},
];

const RES={
  mono:{badge:"Monofilament (polyester)", name:"LE CONTRÔLE", url:"/collections/cordage-monofilament",
    line:"Un polyester te donnera contrôle, prise d'effet et durabilité. C'est le choix des joueurs qui frappent fort. Corde-le 1 à 2 kg plus bas pour préserver ton bras."},
  multi:{badge:"Multifilament", name:"LE CONFORT", url:"/collections/cordage-mutlifilament",
    line:"Un multifilament est doux, puissant et confortable — idéal pour ménager un bras sensible. Un peu moins durable qu'un poly, mais tellement plus agréable."},
  boyau:{badge:"Boyau naturel", name:"LE HAUT DE GAMME", url:"/collections/cordage-boyau",
    line:"Le boyau naturel, c'est le confort et la puissance ultimes, avec une tenue de tension inégalée. Un investissement, mais rien n'égale ce toucher."},
  hybride:{badge:"Hybride (mono + multi)", name:"LE MEILLEUR DES DEUX", url:"/collections/cordages",
    line:"Un montage hybride combine un mono (contrôle/durabilité) et un multi ou boyau (confort/puissance). Le compromis malin pour qui casse mais veut du toucher."},
};

function decide(a){
  // Bras sensible = priorité confort
  if(a.bras==='oui'){ return a.bud==='prem' ? RES.boyau : RES.multi; }
  if(a.prof==='confort'){ return a.bud==='prem' ? RES.boyau : RES.multi; }
  if(a.prof==='controle'){
    if(a.casse==='souvent' && a.bud!=='eco') return RES.hybride;
    return RES.mono;
  }
  if(a.prof==='puissance'){
    if(a.casse==='rare') return a.bud==='prem' ? RES.boyau : RES.multi;
    if(a.casse==='souvent') return RES.hybride;
    return a.bud==='eco' ? RES.multi : RES.hybride;
  }
  return RES.multi;
}
function jauge(a){
  if(a.casse==='souvent') return "Prends plutôt une jauge épaisse (1.30-1.35 mm) pour tenir plus longtemps.";
  if(a.prof==='puissance'||a.prof==='confort') return "Une jauge fine (1.25 mm) t'apportera plus de toucher et d'effet.";
  return "Une jauge intermédiaire (1.25-1.30 mm) est un bon compromis.";
}

let step=0; const ans={};
const quiz=document.getElementById('quiz'), prog=document.getElementById('progress');
function render(){
  prog.innerHTML=Q.map((_,i)=>`<span class="dot ${i<step?'done':''} ${i===step?'on':''}"></span>`).join('');
  const c=Q[step];
  quiz.innerHTML=`<div class="q">${c.q}</div><div class="qhint">${c.hint}</div>
    <div class="opts">${c.opts.map((o,i)=>`<div class="opt" onclick="choose(${i})"><div class="ic">${o.ic}</div><h3>${o.t}</h3><p>${o.d}</p></div>`).join('')}</div>
    ${step>0?`<button class="back" onclick="back()">← Précédent</button>`:''}`;
}
function choose(i){ Object.assign(ans,Q[step].opts[i].v); step++; step<Q.length?render():finish(); }
function back(){ if(step>0){step--;render();} }
function restart(){ step=0; for(const k in ans)delete ans[k]; document.getElementById('result').classList.remove('show'); quiz.style.display=''; prog.style.display=''; render(); window.scrollTo({top:0,behavior:'smooth'}); }
function finish(){
  quiz.style.display='none'; prog.style.display='none';
  const r=decide(ans);
  document.getElementById('rbadge').textContent=r.badge;
  document.getElementById('rtitle').textContent=r.name;
  document.getElementById('rtext').textContent=r.line+" "+jauge(ans);
  const cta=document.getElementById('rcta'); cta.href=r.url; cta.textContent="Voir cette sélection →";
  document.getElementById('ralso').innerHTML=`<a href="/blogs/news/comprendre-les-cordages">Guide cordages</a><a href="/blogs/news/tableau-des-tensions">Tableau des tensions</a><a href="/collections/cordages">Tous les cordages</a>`;
  document.getElementById('result').classList.add('show');
  window.scrollTo({top:0,behavior:'smooth'});
}
render();
window.choose=choose;window.back=back;window.restart=restart;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goatt-lp-adn"] && !Shopify.designMode) return;
  try {
    
(function(){
document.querySelectorAll('.goatt-lp-adn').forEach(function(root){
var pills = root.querySelectorAll('[data-adn-pill]');
var bubbles = root.querySelectorAll('[data-adn-bubble]');
function closeAll(){
pills.forEach(function(p){ p.setAttribute('aria-expanded','false'); });
bubbles.forEach(function(b){ b.classList.remove('is-show'); });
}
pills.forEach(function(p){
p.addEventListener('click', function(){
var i = p.getAttribute('data-adn-pill');
var b = root.querySelector('[data-adn-bubble="'+i+'"]');
var wasOpen = p.getAttribute('aria-expanded') === 'true';
closeAll();
if(!wasOpen && b){ p.setAttribute('aria-expanded','true'); b.classList.add('is-show'); }
});
});
root.querySelectorAll('[data-adn-close]').forEach(function(x){
x.addEventListener('click', function(e){ e.stopPropagation(); closeAll(); });
});
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goatt-lp-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.goatt-lp-cards').forEach(function(root){
    var tabs = root.querySelectorAll('[data-tab]');
    var cards = root.querySelectorAll('.card[data-fr]');
    var grid = root.querySelector('.cardgrid');
    var titleEl = root.querySelector('[data-gamme-title]');
    var carousel = root.querySelector('.carousel');
    var cprev = carousel ? carousel.querySelector('.cbtn.prev') : null;
    var cnext = carousel ? carousel.querySelector('.cbtn.next') : null;
    function step(){ var c = grid.querySelector('.card:not([style*="display:none"])'); return c ? c.getBoundingClientRect().width + 16 : grid.clientWidth * 0.32; }
    function updCarousel(){ if(!grid) return; if(cprev) cprev.disabled = grid.scrollLeft <= 2; if(cnext) cnext.disabled = grid.scrollLeft >= (grid.scrollWidth - grid.clientWidth - 2); }
    if(cprev) cprev.addEventListener('click', function(){ grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if(cnext) cnext.addEventListener('click', function(){ grid.scrollBy({ left: step(), behavior: 'smooth' }); });
    if(grid){ grid.addEventListener('scroll', updCarousel); window.addEventListener('resize', updCarousel); updCarousel(); }
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var fr = t.dataset.tab;
        tabs.forEach(function(x){ x.classList.toggle('on', x === t); });
        cards.forEach(function(c){ c.style.display = (c.dataset.fr === fr) ? '' : 'none'; });
        if(titleEl && t.dataset.title){ titleEl.textContent = t.dataset.title; }
        if(grid){ grid.scrollLeft = 0; updCarousel(); }
      });
    });
    root.querySelectorAll('[data-slider]').forEach(function(sl){
      var slides = sl.querySelectorAll('.slide');
      if(slides.length < 2) return;
      var box = sl.parentNode;
      var prev = box.querySelector('.nav.prev'), next = box.querySelector('.nav.next');
      var dots = box.querySelectorAll('.dot');
      function cur(){ return Math.round(sl.scrollLeft / sl.clientWidth); }
      function go(i){ i = Math.max(0, Math.min(slides.length - 1, i)); sl.scrollTo({ left: i * sl.clientWidth, behavior: 'smooth' }); }
      if(prev) prev.addEventListener('click', function(){ go(cur() - 1); });
      if(next) next.addEventListener('click', function(){ go(cur() + 1); });
      dots.forEach(function(d, i){ d.addEventListener('click', function(){ go(i); }); });
      sl.addEventListener('scroll', function(){ var c = cur(); dots.forEach(function(d, i){ d.classList.toggle('on', i === c); }); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goatt-lp-comparatif"] && !Shopify.designMode) return;
  try {
    
(function(){
  var dataEl = document.getElementById("goatt-cmp-data");
  if(!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);
  var M = DATA.M || [];
  if(!M.length) return;
  M.sort(function(a,b){ return (b.wg||0)-(a.wg||0); });
  var MAXSEL = DATA.maxSel || 3;
  var AX=[["Puissance","puissance"],["Effet","effet"],["Contrôle","controle"],["Stabilité","stabilite"],["Confort","confort"],["Maniabilité","maniabilite"]];
  var COLORS=["#C8E81C","#35e6ff","#ff5db1"];
  var ROWS=[
    {l:"Poids",k:"w",info:"Le poids de la raquette non cordée. Plus lourd = plus de stabilité et de puissance, mais plus exigeant. Plus léger = plus maniable et facile à jouer longtemps, idéal pour débuter."},
    {l:"Tamis",k:"t",info:"La surface du cordage, en cm². Grand tamis = tolérant et puissant, parfait pour progresser. Petit tamis = plus précis, pour joueurs confirmés."},
    {l:"Plan de cordage",k:"cordage",info:"Nombre de cordes verticales × horizontales. Plan ouvert (16x19) = plus d'effet. Plan dense (16x20 / 18x20) = plus de contrôle et de durabilité."},
    {l:"Équilibre",k:"b",info:"Là où se concentre le poids, depuis le manche. Équilibre haut (en tête) = plus de puissance, moins maniable. Équilibre bas (en manche) = plus de contrôle et de maniabilité."},
    {l:"Niveau",k:"lv",info:"Le profil de joueur visé, du débutant (tolérance, facilité) au compétiteur (performance, précision). Choisissez la raquette adaptée à votre niveau actuel."},
    {l:"Prix",k:"price",info:"Prix conseillé du modèle. Le prix final peut varier selon le cordage et les options choisies."}
  ];
  var RANGES=(function(){
    var seen={}, out=[];
    M.forEach(function(m){ if(!seen[m.fr]){ seen[m.fr]=1; out.push([m.fr, m.frl, (typeof m.fro==='number'?m.fro:0)]); } });
    out.sort(function(a,b){ return a[2]-b[2]; });
    return out.map(function(x){ return [x[0], x[1]]; });
  })();
  var R=110,CX=100,CY=100;
  var cmpGamme = RANGES.length ? RANGES[0][0] : null;
  var sel=[];
  var $=function(id){return document.getElementById(id);};
  function pt(i,v){var a=(-90+i*60)*Math.PI/180,r=R*v/100;return[CX+r*Math.cos(a),CY+r*Math.sin(a)];}
  function buildGrid(){var s="";[25,50,75,100].forEach(function(l){s+='<polygon class="ring" points="'+AX.map(function(_,i){return pt(i,l).join(",");}).join(" ")+'"/>';});AX.forEach(function(ax,i){var p=pt(i,100);s+='<line class="spoke" x1="'+CX+'" y1="'+CY+'" x2="'+p[0]+'" y2="'+p[1]+'"/>';var lp=pt(i,123);var anc=Math.abs(lp[0]-CX)<2?"middle":(lp[0]>CX?"start":"end");s+='<text class="axis-l" x="'+lp[0]+'" y="'+(lp[1]+3)+'" text-anchor="'+anc+'">'+ax[0]+'</text>';});$("goatt-cmp-grid").innerHTML=s;}
  function renderSpecs(){$("goatt-cmp-sphead").innerHTML='<tr><th></th>'+sel.map(function(mi,k){return '<th style="color:'+COLORS[k]+'">'+M[mi].n+'</th>';}).join("")+'</tr>';$("goatt-cmp-spbody").innerHTML=ROWS.map(function(r,ri){return '<tr><td><button class="info" data-i="'+ri+'">'+r.l+' <span class="i">i</span></button></td>'+sel.map(function(mi){return '<td class="v">'+(M[mi][r.k]||"—")+'</td>';}).join("")+'</tr>';}).join("")+'<tr class="buyrow"><td></td>'+sel.map(function(mi){return '<td>'+(M[mi].url?'<a class="cbuy" href="'+M[mi].url+'">Acheter</a>':'')+'</td>';}).join("")+'</tr>';Array.prototype.forEach.call($("goatt-cmp-spbody").querySelectorAll(".info"),function(b){b.onclick=function(){showBubble(+b.dataset.i,b);};});}
  function showBubble(i,btn){var bub=$("goatt-cmp-bubble");if(btn.classList.contains("act")){btn.classList.remove("act");bub.classList.remove("show");return;}Array.prototype.forEach.call($("goatt-cmp-spbody").querySelectorAll(".info"),function(x){x.classList.remove("act");});btn.classList.add("act");$("goatt-cmp-bt").textContent=ROWS[i].l;$("goatt-cmp-bp").textContent=ROWS[i].info;bub.classList.add("show");}
  $("goatt-cmp-bx").onclick=function(){$("goatt-cmp-bubble").classList.remove("show");Array.prototype.forEach.call($("goatt-cmp-spbody").querySelectorAll(".info"),function(x){x.classList.remove("act");});};
  function render(){$("goatt-cmp-polys").innerHTML=sel.map(function(mi,k){var m=M[mi],c=COLORS[k];return '<polygon class="poly" points="'+AX.map(function(a,i){return pt(i,m[a[1]]).join(",");}).join(" ")+'" stroke="'+c+'" fill="'+c+'"/>';}).join("");$("goatt-cmp-legend").innerHTML=sel.map(function(mi,k){return '<div class="lg"><span class="sw" style="background:'+COLORS[k]+'"></span>'+M[mi].n+'</div>';}).join("");renderSpecs();Array.prototype.forEach.call(document.querySelectorAll("#goatt-cmp-picker .mchip"),function(ch){var i=+ch.dataset.i,k=sel.indexOf(i);if(k>=0){ch.classList.add("on");ch.style.setProperty("--c",COLORS[k]);}else{ch.classList.remove("on");ch.style.removeProperty("--c");}});}
  function toggle(i){var k=sel.indexOf(i);if(k>=0){if(sel.length>1)sel.splice(k,1);}else{if(sel.length>=MAXSEL)sel.shift();sel.push(i);}render();}
  function gammeLabel(g){for(var i=0;i<RANGES.length;i++){if(RANGES[i][0]===g)return RANGES[i][1];}return "";}
  function gammeIds(g){return M.map(function(m,i){return i;}).filter(function(i){return M[i].fr===g;});}
  function buildPicker(){var ids=gammeIds(cmpGamme);var html='<p class="glabel">'+gammeLabel(cmpGamme)+'</p>'+ids.map(function(i){return '<button class="mchip" data-i="'+i+'"><span>'+M[i].n+'<br><span class="g">'+M[i].g+'</span></span><span class="d"></span></button>';}).join("");var p=$("goatt-cmp-picker");p.innerHTML=html;Array.prototype.forEach.call(p.querySelectorAll(".mchip"),function(ch){ch.onclick=function(){toggle(+ch.dataset.i);};});}
  function renderGammeSel(){var el=$("goatt-cmp-gammesel");if(RANGES.length<2){el.innerHTML="";return;}el.innerHTML=RANGES.map(function(r){return '<button class="gt '+(r[0]===cmpGamme?'on':'')+'" data-fr="'+r[0]+'">'+r[1]+'</button>';}).join("");Array.prototype.forEach.call(el.querySelectorAll(".gt"),function(t){t.onclick=function(){setGamme(t.dataset.fr);};});}
  function setGamme(g){cmpGamme=g;var ids=gammeIds(g);sel=ids.slice(0,Math.min(2,ids.length));renderGammeSel();buildPicker();render();}
  function renderDetail(){var h='<table><thead><tr><th>Modèle</th><th>Poids</th><th>Tamis</th><th>Cordage</th><th>Équilibre</th><th>Niveau</th></tr></thead><tbody>';M.forEach(function(m){h+='<tr><td>'+m.n+'</td><td>'+(m.w||"—")+'</td><td>'+(m.t||"—")+'</td><td>'+(m.cordage||"—")+'</td><td>'+(m.b||"—")+'</td><td>'+(m.lv||"—")+'</td></tr>';});h+='</tbody></table>';$("goatt-cmp-detailtable").innerHTML=h;}
  buildGrid();
  if(cmpGamme){setGamme(cmpGamme);}
  renderDetail();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goatt-lp-guide-manche"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.goatt-lp-guide').forEach(function(root){
    var sizes = root.querySelectorAll('.size');
    var bigEl = root.querySelector('[data-grip-big]');
    var advEl = root.querySelector('[data-grip-advice]');
    if(!bigEl || !advEl) return;
    var selected = root.querySelector('.size.on') || sizes[0];
    function show(el){ if(!el) return; bigEl.textContent = el.getAttribute('data-l'); advEl.textContent = el.getAttribute('data-advice'); }
    function select(el){ selected = el; sizes.forEach(function(s){ var on = s === el; s.classList.toggle('on', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); }); show(el); }
    sizes.forEach(function(s){
      s.addEventListener('mouseenter', function(){ show(s); });
      s.addEventListener('focus', function(){ show(s); });
      s.addEventListener('mouseleave', function(){ show(selected); });
      s.addEventListener('blur', function(){ show(selected); });
      s.addEventListener('click', function(){ select(s); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goatt-lp-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.goatt-lp-hero__cta, .goatt-lp-hero__played').forEach(function(a){
    a.addEventListener('click', function(e){
      var href = a.getAttribute('href') || '';
      if(href.charAt(0) === '#' && href.length > 1){
        var t = document.getElementById(href.slice(1));
        if(t){ e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
